import { render, staticRenderFns } from "./AttachCompany.vue?vue&type=template&id=2614364a&scoped=true"
import script from "./AttachCompany.vue?vue&type=script&lang=js"
export * from "./AttachCompany.vue?vue&type=script&lang=js"
import style0 from "./AttachCompany.vue?vue&type=style&index=0&id=2614364a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2614364a",
  null
  
)

export default component.exports